/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from "@ember/object";
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { modifier } from "ember-modifier";

type Value = string;

interface Signature {
  Element: HTMLDivElement;
  Args: {
    value: Value;
    onInit: (value: Value) => void;
    valueMapper: (value: Value) => string;
  };
}

export default class extends Component<Signature> {
  @tracked ariaLabel = "";

  constructor(owner: unknown, args: Signature["Args"]) {
    super(owner, args);
    this.args.onInit(this.args.value);
  }

  get value(): string {
    return this.args.valueMapper(this.args.value);
  }

  setAria = modifier(this._setAria);

  @action
  _setAria(el: HTMLElement): void {
    this.ariaLabel = el.innerText.trim();
  }
}
